import { render, staticRenderFns } from "./IconSvgNYSSCPAExchange.vue?vue&type=template&id=22e12d24&scoped=true&"
import script from "./IconSvgNYSSCPAExchange.vue?vue&type=script&lang=js&"
export * from "./IconSvgNYSSCPAExchange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e12d24",
  null
  
)

export default component.exports